import { API } from '@/api/api.ts';

export interface PrefetchEndpoint {
  api: API;
  url: string;
  params?: Record<string, unknown>;
}

export const PREFETCH_ENDPOINTS: PrefetchEndpoint[] = [
  // Example (actual endpoints should be defined based on app needs):
  // {
  //   api: API.VESSEL,
  //   url: '/equipment-category',
  //   params: { page: 2, limit: 12 },
  // },
];
